import PropTypes from "prop-types"
import React, { useState, useEffect, useMemo } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledDropdown,
} from "reactstrap"
import {
  GridBoolValue,
  Modifieddata,
  Modifieddatas,
  TrackScreenResolution,
} from "pages/Admin/ManageTrackProfile/trackcols"
import { useDispatch, useSelector } from "react-redux"
import {
  getAllCategory,
  getprofiledata,
  onAddNewProfile,
  onUpdateProfile,
  onDeleteProfile,
} from "store/trackprofile/action"
import FilterLayout from "./Filterlayout"
import TrackprofileForm from "./trackprofileForm"
import Breadcrumbs from "components/Common/Breadcrumb"
import TableContainer from "../Components/ManageSettingsTableContainer"
import DeleteModal from "components/Common/DeleteModal"
import MobileResize from "common/Resize/MobileResize"

const Track_Profile = props => {
  const screenresolution = [
    {
      label: "Low",
      value: "L",
    },
    {
      label: "Medium",
      value: "M",
    },
    {
      label: "High",
      value: "H",
    },
  ]

  const dispatch = useDispatch()
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [filtersubCategory, setfiltersubCategory] = useState([])
  const [selectedUserData, setuserList] = useState(undefined)
  const [selectedSubcategory, setselectedSubcategory] = useState(undefined)
  const [selectedMainCategory, setselectedMainCategory] = useState(undefined)
  const [selectedData, setselectedData] = useState({})
  const [sort, setSort] = useState({ direction: "Ascending", accessor: "name" })
  // Form value  Handling
  const [tabledata, settabledata] = useState([])
  const [pageSize, setpageSize] = useState(10)
  const [pageindex, setpageindex] = useState(0)
  const [selectedRow, setselectedRow] = useState({})
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteprofile, setDeleteprofile] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 921)
  // Get company ID from user Login
  const companyid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data
    ?.companysetting?.companyid

  const params = {
    companyid: companyid,
    pageSize: pageSize,
    // pageNumber: 1,
    pageNumber: pageindex + 1 ,
    SortField: sort.accessor,
    Direction: sort.direction,
    categoryid: selectedMainCategory ? selectedMainCategory?.id : 0,
    subCategoryid: selectedSubcategory ? selectedSubcategory?.id : 0,
    userid: selectedUserData ? selectedUserData?.userId : 0,
  }

  // handle Main Category
  const categoryFilter = value => {
    setselectedMainCategory(value)
    setselectedSubcategory(null)
    // setpageindex(0)
  }

  // handle Sub-category
  const subcategoryFilter = value => {
    setselectedSubcategory(value)
  }

  //handle selectedUserData
  const userListFilter = value => {
    setuserList(value)
  }

  const handleCancel = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }

  // Handle API Call
  useEffect(() => {
    dispatch(getAllCategory())
    dispatch(getprofiledata(params))
  }, [])

  const {
    maincategoryList,
    subcategoryList,
    userData,
    trackprofileData,
    addProfileSuccess,
    updateprofileSuccess,
    totalCount,
    addProfileSuccessCode,
    companySetting,
    accessSetting,
    deleteprofileSuccess,
    accessgroupname,
  } = useSelector(state => ({
    maincategoryList: state?.trackprofile?.maincategorylist,
    subcategoryList: state?.trackprofile?.subCategorylist,
    userData: state?.trackprofile?.userList,
    totalCount: state?.trackprofile?.profileData?.count,
    trackprofileData: state?.trackprofile?.profileData?.data || [],
    addProfileSuccess: state?.trackprofile?.addprofile?.status,
    updateprofileSuccess: state?.trackprofile?.updateprofile?.status,
    addProfileSuccessCode: state?.trackprofile?.addprofile?.statusCode,
    companySetting: state?.Login?.userDetails?.data,
    accessSetting: state?.Login?.accessDetails?.data,
    deleteprofileSuccess: state?.trackprofile?.deleteprofileSuccess?.status,
    accessgroupname: state?.Login?.usersDetails?.data,
  }))
  const hideTrackProfilebutton = accessSetting?.createTrackProfile
  const accessGroupname = accessgroupname?.accessgroupname === "Admin"

  useEffect(() => {
    settabledata(trackprofileData)
  }, [trackprofileData])
  //  Handle Trackprofile API After add or Update success
  useEffect(() => {
    if (
      addProfileSuccess === "Success!" ||
      updateprofileSuccess === "Success!" ||
      deleteprofileSuccess === "Success"
    ) {
      setselectedMainCategory(null)
      setselectedSubcategory(null)
      setuserList(null)
      setfiltersubCategory(subcategoryList)
      dispatch(getprofiledata(params))
    }
  }, [addProfileSuccess, updateprofileSuccess, deleteprofileSuccess])

  // FIlter Based on Dropdown
  useEffect(() => {
    const newParam = {
      companyid: companyid,
      pageSize: pageSize,
      pageNumber: 1,
      // pageNumber: pageindex + 1 ,
      categoryid: selectedMainCategory ? selectedMainCategory?.id : 0,
      subCategoryid: selectedSubcategory ? selectedSubcategory?.id : 0,
      userid: selectedUserData ? selectedUserData?.userId : 0,
      SortField: sort.accessor,
      Direction: sort.direction,
    }
    // setpageindex(0)
    if (
      selectedUserData != undefined ||
      selectedUserData != null ||
      selectedMainCategory != undefined ||
      selectedMainCategory != null ||
      selectedSubcategory != undefined ||
      selectedSubcategory != null
    ) {
      dispatch(getprofiledata(newParam))
    }
  }, [selectedMainCategory, selectedSubcategory, selectedUserData])

  //Filter sub-categoryDrop-down
  useEffect(() => {
    const filteredData = selectedMainCategory?.id
      ? subcategoryList?.filter(
          el => el?.categoryId === selectedMainCategory?.id
        )
      : subcategoryList
    setfiltersubCategory(filteredData)
  }, [selectedMainCategory])

  useEffect(() => {
    setfiltersubCategory(subcategoryList)
  }, [subcategoryList])

  //delete profile

  const onClickDelete = id => {
    setDeleteprofile(id)
    setDeleteModal(true)
  }

  const handleDeleteOrder = () => {
    if (deleteprofile.id) {
      dispatch(onDeleteProfile(deleteprofile.id))
      setDeleteModal(false)
    }
  }

  // Customber Column
  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "Profile Name",
        accessor: "name",
        disableFilters: true,
        sort:true,
        filterable: true,
        sortDirection: sort.accessor === "name" ? sort.direction : "none",
      },
      {
        Header: "Work Report Validity",
        accessor: "workreportvalidity",
        disableFilters: true,
        sort:true,
        filterable: true,
        sortDirection:
          sort.accessor === "workreportvalidity" ? sort.direction : "none",
      },
      {
        Header: "Screenshot Interval",
        accessor: "screenshotinterval",
        disableFilters: true,
        sort:true,
        filterable: true,
        sortDirection:
          sort.accessor === "screenshotinterval" ? sort.direction : "none",
      },
      {
        Header: "Idle Interval",
        accessor: "idleinterval",
        disableFilters: true,
        filterable: true,
        sort:true,
        sortDirection:
          sort.accessor === "idleinterval" ? sort.direction : "none",
      },
      {
        Header: "Break Interval",
        accessor: "breakinterval",
        disableFilters: true,
        filterable: true,
        sort:true,
        sortDirection:
          sort.accessor === "breakinterval" ? sort.direction : "none",
      },
      {
        Header: "Capture Screen",
        accessor: "capturescreen",
        disableFilters: true,
        sort:false,
        filterable: true,
        // sortDirection: sort.accessor === 'capturescreen' ? sort.direction : 'none',
        Cell: row => <div style={{ textAlign: !isMobile ? "center" : "start" }}><GridBoolValue {...row} /></div>,
      },
      {
        Header: "Work Report",
        accessor: "workreport",
        disableFilters: true,
        filterable: true,
        sort: false,
        // sortDirection: sort.accessor === 'workreport' ? sort.direction : 'none',
        Cell: row => <div style={{ textAlign: !isMobile ? "center" : "start" }}><GridBoolValue {...row} /></div>,
      },
      {
        Header: "Sync Interval",
        accessor: "syncinterval",
        disableFilters: true,
        filterable: true,
        sort: true,
        sortDirection:
          sort.accessor === "syncinterval" ? sort.direction : "none",
      },
      {
        Header: "Private Log",
        accessor: "privatelog",
        disableFilters: true,
        filterable: true,
        // sortDirection: sort.accessor === 'privatelog' ? sort.direction : 'none',
        Cell: row => <div style={{ textAlign: !isMobile ? "center" : "start" }}><GridBoolValue {...row} /></div>,
      },
      {
        Header: "Manual Hours",
        accessor: "manualhours",
        disableFilters: true,
        sort: false,
        filterable: true,
        // sortDirection: sort.accessor === 'manualhours' ? sort.direction : 'none',
        Cell: row => <div style={{ textAlign: !isMobile ? "center" : "start" }}><GridBoolValue {...row} /></div>,
      },
      {
        Header: "Hours Tracking",
        accessor: "hourstracking",
        disableFilters: true,
        sort: false,
        filterable: true,
        // sortDirection: sort.accessor === 'hourstracking' ? sort.direction : 'none',
        Cell: row => <div style={{ textAlign: !isMobile ? "center" : "start" }}><GridBoolValue {...row} /></div>,
      },
      {
        Header: "Application Tracking",
        accessor: "applicationtracking",
        disableFilters: true,
        sort: false,
        filterable: true,
        // sortDirection: sort.accessor === 'applicationtracking' ? sort.direction : 'none',
        Cell: row => <div style={{ textAlign: !isMobile ? "center" : "start" }}><GridBoolValue {...row} /></div>,
      },
      {
        Header: "Move Hours",
        accessor: "movehrs",
        disableFilters: true,
        sort: false,
        filterable: true,
        // sortDirection: sort.accessor === 'movehrs' ? sort.direction : 'none',
        Cell: row => <div style={{ textAlign: !isMobile ? "center" : "start" }}><GridBoolValue {...row} /></div>,
      },
      {
        Header: "Is Billable",
        accessor: "isbillable",
        disableFilters: true,
        sort: false,
        filterable: true,
        // sortDirection: sort.accessor === 'isbillable' ? sort.direction : 'none',
        Cell: row => <div style={{ textAlign: !isMobile ? "center" : "start" }}><GridBoolValue {...row} /></div>,
      },
      {
        Header: "Allow Break To Active",
        accessor: "allowbreaktoactive",
        disableFilters: true,
        sort: false,
        filterable: true,
        // sortDirection: sort.accessor === 'allowbreaktoactive' ? sort.direction : 'none',
        Cell: row => (
          <div style={{ textAlign: !isMobile ? "center" : "start" }}>
            <GridBoolValue {...row} />
          </div>
        ),
      },
      {
        Header: "Screen Resolution",
        accessor: "screenresolution",
        disableFilters: true,
        filterable: true,
        sort: true,
        sortDirection:
          sort.accessor === "screenresolution" ? sort.direction : "none",
        Cell: row => (
          <div style={{ textAlign: !isMobile ? "center" : "start" }}>
            <TrackScreenResolution {...row} />
          </div>
        ),
      },
      {
        Header: "Last Modified Date ",
        accessor: "lastmodified",
        disableFilters: true,
        filterable: true,
        sort: true,
        sortDirection:
          sort.accessor === "lastmodified" ? sort.direction : "none",
        Cell: row => <Modifieddatas {...row} />,
      },
      {
        Header: "Last Modified Profile",
        accessor: "modifiedbyUsername",
        sort: true,
        disableFilters: true,
        filterable: true,
        sortDirection:
          sort.accessor === "modifiedbyUsername" ? sort.direction : "none",
      },
      {
        Header: "Action",
        accessor: "hideeditButton",
        disableFilters: true,
        sort: false,
        isDummyField: true,
        Cell: cellProps => {
          return (
            <div
              role="buttton "
              style={{
                cursor: "Pointer",
                textAlign: !isMobile ? "center" : "start",
              }}
            >
              <UncontrolledDropdown>
                <DropdownToggle href="#" className="card-drop" tag="i">
                  <i className="mdi mdi-dots-vertical font-size-18" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem
                    href="#"
                    onClick={() => rowEdit(cellProps.row.original)}
                  >
                    Edit
                  </DropdownItem>
                  {accessGroupname == true && (
                    <DropdownItem
                      href="#"
                      onClick={() => onClickDelete(cellProps.row.original)}
                    >
                      Delete
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ]
    return result
  }, [sort, isMobile])

  // Handle Row Modal
  const rowEdit = item => {
    const filteredUserData =
      userData
        ?.map(el => ({
          ...el,
          label: el.userName,
          value: el.userId,
        }))
        .filter(el => el.value === item.userid)[0] || undefined
    const filteredCategoryData =
      maincategoryList
        ?.map(el => ({
          ...el,
          label: el.name,
          value: el.id,
        }))
        .filter(el => el.value === item.categoryId)[0] || undefined
    const filteredSubCategoryData =
      subcategoryList
        ?.map(el => ({
          ...el,
          label: el.name,
          value: el.id,
        }))
        .filter(el => el.value === item.subCategoryId)[0] || undefined
    const filteredScreenResolutionData =
      screenresolution
        ?.map(el => ({
          ...el,
          label: el.label,
          value: el.value,
        }))
        .filter(el => el.value === item.screenresolution)[0] || undefined
    setselectedRow({
      ...item,
      mainCategory: filteredCategoryData,
      subCategory: filteredSubCategoryData,
      screenresolution: filteredScreenResolutionData,
      userlist: filteredUserData,
    })
    setIsEdit(true)
    toggle()
  }

  //HandleClick Function
  const handleCustomerClicks = () => {
    setselectedData({})
    setIsEdit(false)
    toggle()
  }

  // toggel Function
  const toggle = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  const columnHeaderClick = (column, pagesize, pageIndex) => {
    switch (column.sortDirection) {
      case "none":
        setSort({ direction: "Ascending", accessor: column.id })
        handlePageValue({
          pageSize: pagesize,
          pageNumber: pageIndex,
          categoryid: selectedMainCategory ? selectedMainCategory?.id : 0,
          subCategoryid: selectedSubcategory ? selectedSubcategory?.id : 0,
          userid: selectedUserData ? selectedUserData?.userId : 0,
          SortField: column.id,
          Direction: "Ascending",
        })
        break
      case "Ascending":
        setSort({ direction: "Descending", accessor: column.id })
        handlePageValue({
          pageSize: pagesize,
          pageNumber: pageIndex,
          categoryid: selectedMainCategory ? selectedMainCategory?.id : 0,
          subCategoryid: selectedSubcategory ? selectedSubcategory?.id : 0,
          userid: selectedUserData ? selectedUserData?.userId : 0,
          SortField: column.id,
          Direction: "Descending",
        })
        break
      case "Descending":
        setSort({ direction: "Ascending", accessor: column.id })
        handlePageValue({
          pageSize: pagesize,
          pageNumber: pageIndex,
          categoryid: selectedMainCategory ? selectedMainCategory?.id : 0,
          subCategoryid: selectedSubcategory ? selectedSubcategory?.id : 0,
          userid: selectedUserData ? selectedUserData?.userId : 0,
          SortField: column.id,
          Direction: "Ascending",
        })
        break
    }
  }
  const handlePageValue = value => {
    if (!value.noChange) setpageindex(value.pageNumber)
    setpageSize(value.pageSize)
    dispatch(
      getprofiledata({
        ...params,
        ...value,
        pageNumber: value.pageNumber + 1,
        categoryid: selectedMainCategory ? selectedMainCategory?.id : 0,
        subCategoryid: selectedSubcategory ? selectedSubcategory?.id : 0,
        userid: selectedUserData ? selectedUserData?.userId : 0,
      })
    )
  }
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs="12">
              <Breadcrumbs
                title={"Manage Trac Profile"}
                breadcrumbItem={"Manage Trac Profile"}
              />
              <Card className="checked">
                <CardBody className="table-mobileView">
                  <FilterLayout
                    selectedMainCategory={selectedMainCategory}
                    MainCategory={maincategoryList}
                    categoryFilter={categoryFilter}
                    SubCategory={filtersubCategory}
                    selectedSubcategory={selectedSubcategory}
                    subcategoryFilter={subcategoryFilter}
                    UserList={userData}
                    selectedUserData={selectedUserData}
                    userListFilter={userListFilter}
                    buttonname={"Add Trac Profile"}
                    handleCustomerClick={handleCustomerClicks}
                    companySetting={companySetting}
                    hideTrackProfilebutton={hideTrackProfilebutton}
                  />
                  <MobileResize setIsMobile={setIsMobile}>
                    <TableContainer
                      keyField="id"
                      data={tabledata || []}
                      columns={columns}
                      customPageSize={10}
                      totalCount={totalCount || 0}
                      pageindex={pageindex}
                      setpageindex={setpageindex}
                      customPageSizeOptions
                      handlePageValue={handlePageValue}
                      handleTracEditGroup={rowEdit}
                      className="custom-header-css"
                      paginationShow={true}
                      widthControl={true}
                      colspanChange={true}
                      accessGroup={true}
                      onHeaderClick={columnHeaderClick}
                      hideTrackProfilebutton={hideTrackProfilebutton}
                    />
                  </MobileResize>
                  {modal && (
                    <Modal isOpen={modal} toggle={toggle} size="lg">
                      <ModalHeader toggle={toggle} tag="h4">
                        {!!isEdit ? "Edit Trac Profile" : "New Trac Profile"}
                      </ModalHeader>
                      <ModalBody>
                        <TrackprofileForm
                          toggle={toggle}
                          selectedRow={selectedRow}
                          selectedData={selectedData}
                          handleCancel={handleCancel}
                          onAddNewProfile={onAddNewProfile}
                          onUpdateProfile={onUpdateProfile}
                          addProfileSuccessCode={addProfileSuccessCode}
                          companyid={companyid}
                          isEdit={isEdit}
                          companySetting={companySetting}
                          hideTrackProfilebutton={hideTrackProfilebutton}
                        />
                      </ModalBody>
                    </Modal>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Track_Profile.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Track_Profile
